var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMerge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 1.66671C10.8333 1.20647 10.4602 0.833374 9.99996 0.833374C9.53972 0.833374 9.16663 1.20647 9.16663 1.66671V2.50004H2.58329C2.07703 2.50004 1.66663 2.87314 1.66663 3.33337V16.6667C1.66663 17.1269 2.07703 17.5 2.58329 17.5H9.16663V18.3334C9.16663 18.7936 9.53972 19.1667 9.99996 19.1667C10.4602 19.1667 10.8333 18.7936 10.8333 18.3334V17.5H17.4166C17.9229 17.5 18.3333 17.1269 18.3333 16.6667V3.33337C18.3333 2.87314 17.9229 2.50004 17.4166 2.50004H10.8333V1.66671ZM10.8333 3.50004V16.5H17.2333V3.50004H10.8333ZM9.16663 16.5V3.50004H2.76663V16.5H9.16663Z",
    fill: "#161616"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgMerge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merge.0abf05d90984e372b6f9ae1787ba00b3.svg";